import { useQuery } from '@tanstack/react-query';

import adminAxios from '@/apis/admin-api/axios';

import {
  ChargebeeSubscriptionDto,
  GetSubscriptionResponse,
  ProductDto,
  SubscriptionDetails,
} from '../types';

const getSubscription = async (organizationId: string) => {
  const { data } = await adminAxios.post<GetSubscriptionResponse>('/api/Subscription/GetSubscription', {
    organizationId,
  });
  return data;
};

const getChargebeeSubscription = (
  chargebeeSubscription: GetSubscriptionResponse['chargebeeSubscription'],
  index: number
): ChargebeeSubscriptionDto | null => {
  if (Array.isArray(chargebeeSubscription)) {
    return chargebeeSubscription[index] ?? null;
  }
  return index === 0 ? chargebeeSubscription : null;
};

const transformResponse = (
  data: GetSubscriptionResponse,
  tassProductIndex: number,
  sdkProductIndex: number | null,
  sdkProduct: ProductDto | null
): SubscriptionDetails => ({
  productKey: data.products[tassProductIndex].productKey,
  subscriptionType: data.products[tassProductIndex].billingType,
  paymentFrequency: data.products[tassProductIndex].paymentFrequency,
  activeSeats: data.products[tassProductIndex].activeSeats,
  viewerSeats: data.products[tassProductIndex].viewerSeats,
  maxSeats: data.products[tassProductIndex].maxSeats,
  expiresAt: data.products[tassProductIndex].expiresAt ?? '',
  chargebeeSubscription: getChargebeeSubscription(data.chargebeeSubscription, tassProductIndex),
  sdkChargebeeSubscription:
    sdkProductIndex !== null ? getChargebeeSubscription(data.chargebeeSubscription, sdkProductIndex) : null,
  sdkProduct: sdkProduct,
});

export const useGetSubscription = (organizationId: string) => {
  return useQuery({
    queryKey: ['subscription', organizationId],
    queryFn: () => getSubscription(organizationId),
    enabled: !!organizationId,
    refetchOnWindowFocus: false,
    select: (data: GetSubscriptionResponse): SubscriptionDetails => {
      if (data.products[0].productKey === 'TASS') {
        return transformResponse(
          data,
          0,
          data.products.length > 1 ? 1 : null,
          data.products.length > 1 ? data.products[1] : null
        );
      } else {
        return transformResponse(data, 0, 0, data.products[0]);
      }
    },
  });
};
